import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-71">
      <div className="max-w-3xl mx-auto bg-blue-50 rounded-3xl p-8 md:p-12 text-center border border-blue-100" data-id="element-72">
        <div className="flex justify-center mb-6" data-id="element-73">
          <div className="bg-blue-100 p-4 rounded-full" data-id="element-74">
            <ShieldCheckIcon className="w-16 h-16 text-blue-600" data-id="element-75" />
          </div>
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-76">
          Garanzia di Soddisfazione 100%
        </h2>
        <h3 className="text-xl font-bold text-blue-600 mb-4" data-id="element-77">
          45 Giorni - Senza Domande
        </h3>
        <p className="text-lg text-gray-700 mb-6" data-id="element-78">
          Puoi provare il Mega-Pack senza alcun rischio. Hai 45 giorni di tempo
          per testare i materiali nelle tue classi.
        </p>
        <p className="text-gray-600" data-id="element-79">
          Se per qualsiasi motivo non sei soddisfatto dei risultati, puoi
          richiedere la restituzione del 100% del tuo denaro. Una mail semplice,
          senza domande.
        </p>
      </div>
    </section>;
}